import { HighchartsReactProps } from 'highcharts-react-official'
import styles from './styles.module.scss'
import sharedConfig from '../sharedConfig'
import chartOptionsMerge from '../chartOptionsMerge'

const defaultConfig: HighchartsReactProps = {
  chart: {
    type: 'solidgauge',
    height: '50%',
  },
  pane: {
    center: ['50%', '94%'], // Adjust the vertical center downwards
    size: '188%',
    startAngle: -90,
    endAngle: 90,
    background: {
      backgroundColor: 'transparent',
      innerRadius: '60%',
      outerRadius: '100%',
      shape: 'arc',
      className: styles.gaugeBackground,
    },
  },
  tooltip: {
    enabled: false,
  },
  series: [
    {
      data: [0],
      dataLabels: {
        format: '',
      },
    },
  ],
  // the value axis
  yAxis: {
    min: 0,
    max: 0,
    stops: [],
    lineWidth: 0,
    tickWidth: 0,
    tickAmount: 2,
    tickInterval: 0,
    className: styles.gaugeYAxis,
    labels: {
      y: 24,
      enabled: false,
      useHTML: true,
      style: { color: 'revert-layer' },
    },
  },
  plotOptions: {
    solidgauge: {
      clip: false,
      animation: {
        enabled: true,
      },
      dataLabels: {
        y: -45,
        useHTML: true,
        enabled: true,
        borderWidth: 0,
      },
    },
  },
}

export const defaultOptions = chartOptionsMerge(defaultConfig, sharedConfig)
